import {Controller} from "@hotwired/stimulus"

// Guards a remote form against duplicate and empty submits. The trigger buttons invoke submit() on
// click instead of an inline handler: the first click submits the form through jquery_ujs and every
// further click is ignored until the in-flight request completes. A submit with nothing selected is
// stopped with an info toast instead of sending a request that would approve nothing.
export default class extends Controller {
  static targets = ["form"]
  static values = {emptyMessage: String}

  connect() {
    this.submitting = false
    this.onComplete = this.onComplete.bind(this)
  }

  submit(event) {
    event.preventDefault()

    const jq = window.jQuery
    if (!jq || !this.hasFormTarget || this.submitting) return

    const $form = jq(this.formTarget)

    if (!$form.find('input[type="checkbox"]:checked').length) {
      this.notifyNothingSelected()
      return
    }

    this.submitting = true
    $form.one("ajax:complete", this.onComplete)
    $form.trigger("submit")
  }

  onComplete() {
    this.submitting = false
  }

  notifyNothingSelected() {
    const message = this.emptyMessageValue || "Er is niets geselecteerd."
    if (typeof window.toast_message === "function") {
      window.toast_message({message_type: "info", message_content: message})
    }
  }
}
